import { QuizCard } from '@/shared/components/QuizCardV2';
import { type LearningMaterial } from '@/views/build/modal/LearningMaterialUploadModal';
import { MaterialContentSection } from './MaterialContentSection';
import { MaterialInfoHeader } from './MaterialInfoHeader';
export interface LearningMaterialCardProps {
  learningMaterial: LearningMaterial;
}
export const LearningMaterialCard = ({
  learningMaterial
}: LearningMaterialCardProps) => <QuizCard.Root data-sentry-element="unknown" data-sentry-component="LearningMaterialCard" data-sentry-source-file="LearningMaterialCard.tsx">
    <QuizCard.Header data-sentry-element="unknown" data-sentry-source-file="LearningMaterialCard.tsx" />
    <div className="flex w-full flex-col gap-lg pb-xl">
      <MaterialInfoHeader type={learningMaterial.type} allowReopenDuringPlay={learningMaterial.allowReopenDuringPlay} data-sentry-element="MaterialInfoHeader" data-sentry-source-file="LearningMaterialCard.tsx" />
      <MaterialContentSection learningMaterial={learningMaterial} data-sentry-element="MaterialContentSection" data-sentry-source-file="LearningMaterialCard.tsx" />
    </div>
  </QuizCard.Root>;